import { hasConfigDataUrl } from 'components.modules.gen/placeholder-dataurl/dataUrl-main.js';
import { DataUrlComponent } from 'components.modules.gen/placeholder-dataurl/dataUrlComponent.js';
import { RenderSuspenseComponent } from 'components.modules.gen/placeholder-dataurl/renderSuspenseComponent.js';
import { IModuleConfig } from 'redux-state/layout/types.modules.js';
import { messageLog } from 'utilities/helpers/logger/message-logger.js';
import { ModulePath } from 'utilities/modulePath/modulePath.js';
import { getModuleComponentWithErrorBoundary } from './module-build.js';

/** Lazy load module */
export const ModuleLoad = ({
  config,
  modulePath,
  isDrawer,
}: {
  config: IModuleConfig;
  modulePath: ModulePath;
  isDrawer?: boolean;
}) => {
  if (!config.name) {
    messageLog.error('Error: Module Has No Name', ['config', config]);
  }
  if (hasConfigDataUrl(config)) {
    /** Make fetch request for addutional data  */
    return (
      <DataUrlComponent
        key={`${config.name}`}
        isDrawer={isDrawer}
        modulePath={modulePath}
        config={config}
        // needed to get load data url
        childModuleName={config.name}
      />
    );
  }
  const ModuleComponent = getModuleComponentWithErrorBoundary(config.name);
  if (ModuleComponent) {
    return (
      <RenderSuspenseComponent
        key={`${config.name}`}
        config={config}
        isDrawer={isDrawer}
        modulePath={modulePath}
        childModuleName={config.name}
      >
        {ModuleComponent}
      </RenderSuspenseComponent>
    );
  }
  return null;
};
